module.exports = __webpack_public_path__ + "static/un-laptop-06875dcd188832e3412c352872f85c12.png";